import { PayloadAction } from '../../../../../store.model';
import { filterSummaryByBehaviour } from '../function/filter-summary-by-behaviour.function';
import { filterSummaryByDateRange } from '../function/filter-summary-by-date-range.function';
import { filterSummaryByKeyword } from '../function/filter-summary-by-keyword.function';
import { filterSummaryByParticipant } from '../function/filter-summary-by-participant.function';
import { filterSummaryBySubBehaviour } from '../function/filter-summary-by-sub-behaviour.function';
import { sortSummary } from '../function/sort-summary.function';
import { ActionType } from '../transcript-summary.action';
import { TranscriptSummaryState } from '../transcript-summary.state';

import { FilterSummary } from './filter-summary.action';

export function filterSummaryReducer(
    state: TranscriptSummaryState,
    action: PayloadAction<ActionType, FilterSummary>,
): TranscriptSummaryState {
    try {
        let nextFiltered = filterSummaryByDateRange(
            action.payload.opts.dateRange,
            state.transcriptCategories,
        );
        nextFiltered = filterSummaryByParticipant(
            action.payload.opts.participant,
            nextFiltered,
        );
        nextFiltered = filterSummaryByBehaviour(
            action.payload.opts.behaviourId,
            nextFiltered,
        );
        nextFiltered = filterSummaryBySubBehaviour(
            action.payload.opts.subBehaviourId,
            nextFiltered,
        );
        nextFiltered = filterSummaryByKeyword(
            action.payload.opts.keyword,
            nextFiltered,
        );

        nextFiltered = sortSummary(state.orderBy, nextFiltered);

        return {
            ...state,
            filteredTranscriptCategories: nextFiltered,
            filterOpts: action.payload.opts,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
